<template>
  <base-form
    class="dynamic-query"
    ref="queryForm"
    v-model="queryFormObj"
    labelWidth="120px"
    @keyup.enter.native="enterQuery"
    :form-items="formItems"
    inline
  >
  </base-form>
</template>
<script>
export default {
  name: 'dynamic-query',
  props: {
    bid: String,
    product: String,
  },
  data() {
    return {
      queryFormObj: {},
      formItems: [],
      columns: [],
      optionFields: [],
    }
  },
  methods: {
    enterQuery() {
      //   this.$refs.table.query.PageIndex = 1
      //   this.$refs.table.refreshData()
      this.$emit('enter-query', this.queryFormObj)
    },
    getFiled(bid) {
      if (!bid) {
        this.optionFields = []
        this.formItems = []
        this.columns = []
        this.$emit('columns-change', this.columns)
        this.initOptions()
        return
      }
      this.$post(
        'brandOrField/getFiled',
        {
          bid,
        },
        null,
        null,
        false
      ).then((resp) => {
        if (resp.data.code == 0) {
          var fields = resp.data.data
          if (fields && fields.length > 0) {
            var columns = []
            var formItems = []
            var optionFields = []
            for (var field of fields) {
              columns.push({
                bind: {
                  label: field.clum_desc,
                  prop: field.clum_name,
                },
              })
              //如果是查询列
              if (field.query_clum) {
                var formItem = {
                  label: field.clum_desc,
                  prop: field.clum_name,
                  labelWidth: 'auto',
                }
                //是否为文本框
                if (field.ele_type) {
                  formItem.bind = {
                    placeholder: 'please enter',
                    style: 'min-width:210px;max-width:260px;',
                  }
                  //   formItem.on = {
                  //     input: () => {
                  //       clearTimeout(this.layElementQuery)
                  //       this.layElementQuery = setTimeout(() => {
                  //         this.$refs.table.query.PageIndex = 1
                  //         this.$refs.table.refreshData()
                  //       }, 500)
                  //     },
                  //   }
                } else {
                  optionFields.push(field.clum_name)
                  formItem.component = 'form-select'
                  formItem.bind = {
                    placeholder: 'please select',
                    clearable: true,
                    filterable: true,
                    options: [],
                  }
                  //   formItem.on = {
                  //     change: () => {
                  //       console.log(arguments)
                  //     },
                  //   }
                }
                formItems.push(formItem)
              }
            }
            this.optionFields = optionFields
            this.formItems = formItems
            this.columns = columns

            this.$emit('columns-change', columns)

            this.initOptions()
          }
        } else {
          console.log('请求发生错误=>', resp.data)
        }
      })
    },
    initOptions() {
      if (!this.bid) {
        for (var item of this.formItems) {
          if (item.component == 'form-select') {
            item.value = null
            item.bind.options = []
          }
          item.value = null
        }
        return
      }
      this.$postObj(
        'queryData/getFileDisdData',
        {
          bid: this.bid,
          product: this.product,
          fields: this.optionFields.join(','),
        },
        null,
        null,
        false
      ).then((resp) => {
        if (resp.data.code == 0) {
          var data = resp.data.data
          for (var item of this.formItems) {
            var optionVal = data[item.prop]
            if (optionVal) {
              var options = []
              for (var option of optionVal) {
                if (option) {
                  options.push({
                    label: option,
                    value: option,
                  })
                }
              }
              item.bind.options = options
            }
          }
        } else {
          console.log('请求发生错误=>', resp.data)
        }
      })
    },
  },
  watch: {
    bid: {
      immediate: false,
      handler(newVal) {
        this.getFiled(newVal)
      },
    },
    queryFormObj: {
      deep: true,
      handler(newVal) {
        this.$emit('change', newVal)
      },
    },
  },
}
</script>